export const ARBITRATIONS_PDF_ROUTE_NAME = 'arbitrations-pdf'
export const MANAGED_PORTFOLIO_REPORTING_ROUTE_NAME = 'managed-portfolio-reporting-pdf'
export const ESTATE_REPORT_ROUTE_NAME = 'estate-report-pdf'
export const MODEL_PORTFOLIO_ROUTE_NAME = 'model-porfolio-pdf'

export const PDF_ROUTE_NAMES = [ARBITRATIONS_PDF_ROUTE_NAME, MANAGED_PORTFOLIO_REPORTING_ROUTE_NAME, ESTATE_REPORT_ROUTE_NAME, MODEL_PORTFOLIO_ROUTE_NAME]